import React from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import 'styles/blocks/selector.scss';
import FilterUIElement from 'components/ThreeJs/assets/filter/elementsUI/FilterUIElement';
import camelToDash from './camelToDash';
import InfoBox from './InfoBox';

const GlassProductSelector = ({ name, uiHandlerRef, wrapperClass, labelClass, runwayIndex }) => {
	const dashKey = camelToDash(name);
	const { t } = useTranslation('configurationCategory');
	let label = t(name);
	let infoLabel = t(`${name}_info`);

	const labelClasses = classNames(wrapperClass, {
		'runway-item': runwayIndex !== undefined,
	});

	const style = runwayIndex !== undefined ? { '--runway-index': runwayIndex } : undefined;

	return (
		<label htmlFor={dashKey.concat('_input')} className={labelClasses} style={style}>
			<FilterUIElement
				isDisabled
				id={dashKey}
				uiHandlerRef={uiHandlerRef}
				defaultVisible={
					dashKey === 'manufacturer' || dashKey === 'clear-glass' || dashKey === 'resistance-class'
				}
			/>
			<div style={{ fontVariant: 'small-caps' }} className={labelClass}>
				{label}
				{infoLabel ? (
					<span className="glass_product_selection_info">
						<sup>
							<InfoBox hoverMessage={infoLabel} />
						</sup>
					</span>
				) : null}
			</div>
		</label>
	);
};

export default GlassProductSelector;
